module.exports = __webpack_public_path__ + "img/lasource-8.7beeadc3.jpg";